/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import { createAddressWarning } from './address-warning';

export interface IAdressInput {
    id?: string;
    name?: string;
    className: string;
    type: string;
    value: string;
    maxLength?: number;
    additionalAddributes?: object;
    placeholder?: string;
    onChange(event: React.ChangeEvent<HTMLInputElement>): void;
    hasWarning?(name: string, value: string): string | void;
}

interface IAdressState {
    warningMessage: string;
}

/**
 * Class definition for an input field within a shipping address form
 */
export class AddressInputComponent extends React.Component <IAdressInput, IAdressState> {
    constructor (props: IAdressInput) {
        super(props);
        this._onInputBlur = this._onInputBlur.bind(this);
        this.state = {warningMessage: ''};
    }

    public render (): JSX.Element {
        const {
            id,
            name,
            className,
            type,
            value,
            maxLength,
            additionalAddributes,
            placeholder,
            onChange,
        } = this.props;
        return (
            <React.Fragment>
            {this.state.warningMessage && createAddressWarning(this.state.warningMessage)}
            <input
                name={name}
                id={id}
                className={`${className}__input ${className}__input-${type}`}
                type={type}
                value={value}
                maxLength={maxLength}
                {...(additionalAddributes || {})}
                placeholder={placeholder}
                onChange={onChange}
                onBlur={this._onInputBlur}
            />
            </React.Fragment>
        );
    }

    private _onInputBlur (el: React.ChangeEvent<HTMLInputElement>): void {
        const hasWarning = this.props.hasWarning && this.props.hasWarning(this.props.name || '', el.target.value);
        if (hasWarning) {
            this.setState({warningMessage: hasWarning});
        } else {
            this.setState({warningMessage: ''});
        }
    }
}